// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LandingPage_wrapper__CHh9D"};